






































































































import { computed, defineComponent } from '@vue/composition-api'
import { CompanyAPI, PipelineAPI } from '@/api/backend-client'
import { useCreateLeadForm } from '@/composables/useCreateLeadForm'
import { availableNewBuildTypes } from '@/api/types'
import { InputSelectOption } from '@/helpers/options'
import i18n from '@/i18n'

export default defineComponent({
    name: 'CreateLeadFormStep1',
    setup() {
        const {
            state,
            usePipelines,
            availableCompanies,
            availablePipelines,
            availableReferralNodeTypes,
            availableSources,
            projects,
        } = useCreateLeadForm()

        const companyOptions = computed<InputSelectOption[]>(() => availableCompanies
            .map(company => ({
                label: company.name,
                value: company.id,
            })))

        const pipelineOptions = computed<InputSelectOption[]>(() => availablePipelines.value
            .map(pipeline => ({
                label: pipeline.name,
                value: pipeline.id,
            })).sort((a, b) => a.label.localeCompare(b.label)))

        const referralTypeOptions = computed<InputSelectOption[]>(() => availableReferralNodeTypes.value
            .map(type => ({
                label: i18n.t(`referral.type.${type}`).toString(),
                value: type,
            })))

        const sourceOptions = computed<InputSelectOption[]>(() => availableSources.value
            .map(source => ({
                label: source.name,
                value: source.id,
            }))
            .sort((a, b) => a.label.localeCompare(b.label)))

        const newBuildTypeOptions = computed<InputSelectOption[]>(() => availableNewBuildTypes()
            .map(type => ({
                label: i18n.t(`new_build_type.${type}`).toString(),
                value: type,
            })))

        async function setTargetCompany(id: string) {
            state.targetPipeline = null
            state.referral.type = null

            // fetch manually, we need to do this to ensure we have *ALL* context
            state.targetCompany = await CompanyAPI.get(id)
        }

        function setNewSource(id: string) {
            state.referral.newSource = availableSources.value.find(source => source.id === id)
        }

        /**
         * Set the target pipeline.
         * We fetch from the server because we need to know it's branches.
         * @param id
         */
        async function setTargetPipeline(id: string|null) {
            state.targetPipeline = id ? await PipelineAPI.get(id) : null
        }

        return {
            state,
            usePipelines,

            companyOptions,
            pipelineOptions,
            referralTypeOptions,
            sourceOptions,
            newBuildTypeOptions,
            projects,

            setNewSource,
            setTargetCompany,
            setTargetPipeline,
        }
    },
})
